import { getApiBaseUrl, requestJson } from "@/lib/api";

export interface ProductionReportRequest {
  from: string;
  to: string;
  customerId?: string | null;
  /** Filtra pelo nome real do cliente do pedido (necessário para os pedidos importados). */
  clientName?: string | null;
  groupByCustomer?: boolean;
}

export interface ProductionReportLine {
  productId: string;
  productName: string;
  unit: string;
  cut?: string | null;
  isProcessed: boolean;
  requestedQty: number;
  grossQty?: number;
  producedQty: number;
  statusCounts: Record<string, number>;
  /** Observação(ões) que o cliente registrou nos itens deste agrupamento. */
  observation?: string | null;
}

export interface ProductionReportCustomerBreakdown {
  customerId: string;
  customerName: string | null;
  /** Número do pedido deste bloco — cada pedido é um bloco próprio, nunca unificado. */
  orderNumber?: number | null;
  orderCount: number;
  productionDate?: string | null;
  deliveryDate?: string | null;
  deliveryObs?: string | null;
  /** Observação do cliente registrada no pedido (instruções de preparo, restrições, etc.). */
  notes?: string | null;
  lines: ProductionReportLine[];
}

export interface ProductionReport {
  from: string;
  to: string;
  orderCount: number;
  lines: ProductionReportLine[];
  totals: {
    productCount: number;
    requestedQty: number;
    producedQty: number;
  };
  byCustomer?: ProductionReportCustomerBreakdown[] | null;
}

export async function fetchProductionReport(req: ProductionReportRequest): Promise<ProductionReport> {
  return requestJson<ProductionReport>("/api/v1/reports/production", {
    method: "POST",
    body: req,
  });
}

export async function downloadProductionReportExport(
  req: ProductionReportRequest,
  format: "pdf" | "xlsx",
): Promise<{ filename: string; blob: Blob }> {
  const response = await fetch(`${getApiBaseUrl()}/api/v1/reports/production/export.${format}`, {
    method: "POST",
    credentials: "include",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(req),
  });
  if (!response.ok) {
    throw new Error("Não foi possível gerar o arquivo");
  }
  const disposition = response.headers.get("content-disposition") ?? "";
  const match = /filename="?([^";]+)"?/i.exec(disposition);
  const filename = match?.[1] ?? `producao.${format}`;
  const blob = await response.blob();
  return { filename, blob };
}
